import { ReactNode } from 'react';

export interface FormFieldInputProps {
  readonly?: boolean;
}

export interface FormFieldDescription {
  key: string;
  label: string | string[] | ReactNode;
  renderInput: (props: FormFieldInputProps) => string | ReactNode | ReactNode[];
  hidden?: boolean;
  fullLabelWidth?: boolean;
  valueLabelWidth?: string;
  formRowItem?: ReactNode;
}

export enum FormFieldType {
  File = 'file',
  Text = 'text',
  Color = 'color',
  Boolean = 'boolean',
  Custom = 'custom',
}
